<template>
  <div class="view-webhook">
    <h5 class="text-semibold mb-5">Webhook (API e notificações)</h5>
    <snow-data-table-header
      addText="Nova configuração"
      @add="add"
      @searching="searching"
      :datePicker="false"
      :filters="false"
    />
    <snow-data-table
      class="my-6"
      :loading="loading"
      :columns="columns"
      :data="integrationList"
    >
      <template v-slot:eventos="{ value }">
        <snow-table-events :events="value" />
      </template>
    </snow-data-table>

    <snow-paginator
      v-model="page"
      :pagination="pagination"
      @change-page="dispatch"
    />

    <responsive-modal
      size="lg"
      v-model="modal"
      :title="integrationToEdit ? 'Editar configuração' : 'Nova configuração'"
    >
      <webhook-modal
        v-model="modal"
        :integrationToEdit="integrationToEdit"
        @refresh="refresh"
        @close="modal = false"
      />
    </responsive-modal>
  </div>
</template>
<script>
import WebhookModal from "@/components/tools/modals/Webhook.vue";
import IntegrationMixins from "@/mixins/integration.js";
import get from "lodash/get";
import { mapState } from "vuex";
export default {
  mixins: [IntegrationMixins],
  components: {
    WebhookModal
  },
  data() {
    return {
      integration: "generic",
      page: 1,
      columns: [
        {
          name: "Produto",
          field: "product_id",
          transform: this.getProductName
        },
        {
          name: "Descrição",
          field: "description"
        },
        {
          name: "Eventos",
          field: "events",
          transform: v => v.map(e => e.event)
        },
        {
          name: "URL",
          type: "link",
          field: "url",
          size: "0.5fr"
        },
        {
          name: "Status",
          field: "status",
          transform: v => (v ? "Ativo" : "Inativo"),
          class: v => (v ? "active-badge" : "inactive-badge"),
          size: "0.5fr"
        },
        {
          name: "",
          type: "menu",
          options: this.getActions
        }
      ]
    };
  },
  mounted() {
    this.$store.commit("integration/setIntegration", this.integration);
    this.dispatch();
  },
  computed: {
    ...mapState("integration", ["integrationList", "pagination", "typeEvents"]),
    ...mapState("product", ["products"]),
    eventsOptions() {
      let options = [...this.typeEvents];
      options.unshift({ id: "", name: "Todos os eventos" });
      return options;
    }
  },
  methods: {
    getProductName(_, item) {
      return get(
        this.products.find(p => p.id === get(item.events[0], "product_id")),
        "name",
        "-"
      );
    },
    getActions(item) {
      return [
        {
          label: "Editar",
          click: this.edit
        },
        {
          label: "Enviar teste",
          click: this.testWebhook
        },
        {
          label: item.status ? "Desativar" : "Ativar",
          click: this.changeStatus
        },
        {
          label: "Excluir",
          class: "text-danger",
          variant: "danger",
          dialog: {
            variant: "negative",
            icon: "ph ph-trash",
            text: "Deseja mesmo excluir esta configuração?",
            action: this.submitDelete,
            buttonText: "Sim, excluir",
            secondaryButtonText: "Não, cancelar"
          }
        }
      ];
    },

    changeStatus(item) {
      let data = item;
      data.status = !item.status;
      data.product_id = item.events[0].product_id;
      this.$store
        .dispatch("integration/putIntegration", data)
        .then(() => {
          this.$message.success(
            `Configuração ${data.status ? "ativada" : "desativada"}`
          );
        })
        .catch(() => {
          this.$message.error(
            "Não foi possível alterar o status da configuração"
          );
        });
    }
  },
  mounted() {
    this.$store.dispatch("product/get", { limit: 500 });
    this.$store.dispatch("integration/getTypeEvents");
  }
};
</script>
